import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./SubscriptionFrequencyForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeSubscriptionFrequency} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "frequencyWeeks", 0);
  return errors.toJS();
}

class ChangeSubscriptionFrequencyFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeSubscriptionFrequency(values.set("subscriptionId", this.props.subscriptionId).toJS())
      .then((response) => {
        if (response.data.changeSubscriptionFrequency.errors.length <= 0) {
          this.props.cancelChangeSubscriptionFrequency();
        } else {
          let errors = createValidationErrors(response.data.changeSubscriptionFrequency.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeSubscriptionFrequency();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const info = fromJS(data.subscriptionInfo);
    let initialValues = {
      frequencyWeeks: info.get("frequencyWeeks")
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        frequency={fromJS(data.subscriptionFrequencyOptions)}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const GET_SUBSCRIPTION = gql`
  query subscriptionInfo($subscriptionId: ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      frequencyWeeks
    },
    subscriptionFrequencyOptions {
      title
      value
    }
  }
`;

const CHANGE_SUBSCRIPTION_FREQUENCY = gql`
  mutation changeSubscriptionFrequency($data: SubscriptionFrequencyInput!) {
    changeSubscriptionFrequency(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_SUBSCRIPTION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(CHANGE_SUBSCRIPTION_FREQUENCY, {
    props: ({ mutate }) => ({
      changeSubscriptionFrequency: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const ChangeSubscriptionFrequencyFormContainerWithData = withProductQuery(ChangeSubscriptionFrequencyFormContainer);

export default connect(null, {cancelChangeSubscriptionFrequency})(ChangeSubscriptionFrequencyFormContainerWithData);